import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../redux/revenueCategoriesSagas";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { SearchInput } from "../../../../components/form/Input/Input";

const filterByOptions = [
  { id: "tags", name: "Tag" },
  { id: "search", name: "Sales Packages Names" }
];

const dropdownSettings = {
  tags: "filter_tag",
  search: "filter_name"
};

export default function FilterCategories({ reset }) {
  const dispatch = useDispatch();

  const { filter_by_tag } = useSelector((state) => state.revenueCategories.filters);

  const [selectedFilterByOption, setSelectedFilterByOption] = useState(null);
  const [showInactive, setShowInactive] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({ type: null, data: null });

  const [showUpdateBtn, setShowUpdateBtn] = useState(false);

  const onFilterByChange = (data) => {
    setShowUpdateBtn(false);

    if (selectedFilterByOption && selectedFilterByOption.id == data.id) {
      setSelectedFilterByOption(null);
      setCurrentFilter({ type: null, data: null });
      return;
    }

    setSelectedFilterByOption(data);
    setCurrentFilter({ type: data.id, data: null });
  };

  const onChange = (data, type) => {
    setCurrentFilter({ data, type });

    setShowUpdateBtn(!!data);
  };

  const onUpdate = (param = {}) => {
    reset();
    setShowUpdateBtn(false);

    dispatch(
      fetchCategories({
        key: dropdownSettings[currentFilter.type],
        data: currentFilter.data,
        show_inactive: showInactive,
        ...param
      })
    );
  };

  const onShowInactiveClick = () => {
    setShowInactive(!showInactive);
    onUpdate({ show_inactive: !showInactive });
  };

  return (
    <div className="revenue-categories__filters">
      <div className="revenue-categories__filterBy">
        <p>Filter By:</p>
        <Dropdown
          height={275}
          haveOnSelectChange
          placeholder="Please choose filter type"
          options={filterByOptions}
          selectedFilters={selectedFilterByOption}
          numberDisplayed={1}
          onSelectChange={onFilterByChange}
        />
      </div>
      <div className="revenue-categories__filters-dynamic">
        {selectedFilterByOption && (
          <>
            {selectedFilterByOption.id == "tags" && (
              <Dropdown
                height={275}
                haveOnSelectChange
                placeholder="Please choose tag"
                options={filter_by_tag}
                selectedFilters={currentFilter.data}
                numberDisplayed={1}
                onSelectChange={(data) => onChange(data, "tags")}
              />
            )}

            {selectedFilterByOption.id == "search" && (
              <div className="search">
                <SearchInput
                  placeholder="Search..."
                  value={currentFilter.data ?? ""}
                  onChange={(value) => onChange(value, "search")}
                  onClear={() => onChange("", "search")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && currentFilter.data) {
                      onUpdate();
                    }
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>

      <button
        className={`button button--${showInactive ? "primary" : "secondary"}`}
        onClick={onShowInactiveClick}
      >
        Show Inactive
      </button>

      {showUpdateBtn && (
        <button className="button button--primary" onClick={onUpdate}>
          Update
        </button>
      )}
    </div>
  );
}
